import React from "react"
import { Box } from "@mui/material"
import { Link } from "react-router-dom"
import dummy from "../../images/dummy-image.jpg"
import survice from "../../images/calendar.png"
import tick from "../../images/tick.svg"
import pickedMoney from "../../images/picked-money.png"
import * as Style from "./style"
import { useAppSelector } from "../../app/hooks"
type Props = {}
export default function DummyChatSecreen({}: Props) {
  const userInfo = useAppSelector((state: any) => state.auth?.userInfo)
  return (
    <div>
      {" "}
      <Box>
        <div className="d-flex gap-2 align-items-center justify-content-center">
          <img
            src={userInfo?.user?.profilePic || dummy}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "cover",
              borderRadius: "50%",
            }}
          />
          <h3 className="text-sec">
            Welcome <span>{userInfo?.user?.name}</span>
          </h3>
        </div>
        <Style.Overview>
          <div className="card_sec d-flex flex-column  flex-xl-row gap-3">
            <div className="card_content">
              <img src={survice} />
              <h3>Flexible Jobs</h3>
              <ul>
                <li>
                  <img src={tick} />
                  Choose Jobs That Fit Your Schedule And Preferences.
                </li>
                <li>
                  <img src={tick} />
                  Get Matched With Customers Based On Your Skills And
                  Availability.
                </li>
                <li>
                  <img src={tick} />
                  Receive Instant Notifications For New Job Opportunities.
                </li>
              </ul>

              <span>
                <Link
                  to={"/dashboard/approved-job"}
                  style={{ fontWeight: "700" }}
                  className="view-profile"
                >
                  See Jobs
                </Link>
              </span>
            </div>
            <div className="card_content">
              <img src={pickedMoney} />
              <h3>Quick Payments</h3>
              <ul>
                <li>
                  <img src={tick} />
                  Get Paid Promptly After Each Service
                </li>
                <li>
                  <img src={tick} />
                  Track Your Booking Service In Real-Time.
                </li>
                <li>
                  <img src={tick} />
                  Earn Fair Wages For Your Services.
                </li>
              </ul>

              <span>
                <Link
                  to={"/dashboard/jobs"}
                  style={{ fontWeight: "700", marginTop: "10px" }}
                  className="view-profile"
                >
                  Apply Now
                </Link>
              </span>
            </div>
          </div>
        </Style.Overview>
      </Box>
    </div>
  )
}
